import locale from "localization/en";
import styles from "../cash-noncash.module.scss";
import { Title } from "components/commons";
import useDataTable from "hooks/useDataTable";
import { initialShiftRecordFilterState } from "modules/records/shift-records/shift-records-filter.state";
import DataTableV2 from "components/commons/data-table/data-table-v2";
import { keyAccountCollectionMapper } from "./key-accounts.mapper";
import { keyAccountCollectionColumn } from "./key-accounts-column";

const ShiftDetailsKeyAccounts = ({ shift }) => {
  const { table } = useDataTable({
    value: shift?.keyAccountCollection,
    filter: { initialState: initialShiftRecordFilterState(), mapper: (val) => val },
    table: {
      key: "keyAccountCollection",
      name: "keyAccountCollection",
      mapper: (val) => keyAccountCollectionMapper({ val }),
      columns: keyAccountCollectionColumn,
    },
  });

  return (
    <>
      <Title small black>
        {locale.keyAccountCollections}
      </Title>
      <div className={styles.spacer10} />
      <div className={styles.tableContainer}>
        <DataTableV2 {...table} hideNoSearchResultRender tableVersion="v2" hidePagination />
      </div>
      <div className={styles.spacer50} />
    </>
  );
};

export default ShiftDetailsKeyAccounts;
